import { Translations } from './types';

export const es: Translations = {
  seo: {
    home: {
      title: 'Andrés Luna | Coach Ejecutivo de Carrera en HSE y ESG',
      metaDescription: 'Coaching ejecutivo 1:1 para profesionales de las Américas. Claridad, posicionamiento estratégico y crecimiento de carrera internacional con Andres Luna.',
      ogTitle: 'Andres Luna — Executive Career Coach',
      ogDescription: 'Coaching ejecutivo 1:1 para profesionales que quieren crecer con claridad, estrategia y propósito.',
    },
    coaching: {
      title: 'Coaching Ejecutivo de Carrera 1:1 | Andres Luna',
      metaDescription: 'Sesiones de coaching ejecutivo personalizadas. Posicionamiento, liderazgo, internacionalización y estrategia de carrera para profesionales de las Américas.',
      ogTitle: 'Coaching Ejecutivo 1:1 — Andres Luna',
      ogDescription: 'Coaching estratégico para profesionales que quieren avanzar con claridad y posicionamiento.',
    },
    about: {
      title: 'Sobre Andrés Luna | Coach Ejecutivo, HSE, ESG y Liderazgo',
      metaDescription: 'Conoce a Andres Luna: Executive Career Coach con 17+ años de experiencia ejecutiva internacional en HSE, ESG, sostenibilidad y liderazgo. Fundador de GreenIn.',
      ogTitle: 'Sobre Andrés Luna — Coach Ejecutivo y Estratega de Liderazgo',
      ogDescription: 'Coach ejecutivo con experiencia real en liderazgo internacional, HSE, ESG y desarrollo profesional estratégico.',
    },
    interviews: {
      title: 'Entrevistas y Medios | Andres Luna — Liderazgo y Crecimiento',
      metaDescription: 'Entrevistas, podcasts y medios sobre liderazgo, migración profesional, HSE, ESG e internacionalización de carrera con Andres Luna.',
      ogTitle: 'Entrevistas y Medios — Andres Luna',
      ogDescription: 'Conversaciones sobre liderazgo, crecimiento profesional y migración estratégica.',
    },
    talks: {
      title: 'Charlas y Conferencias | Andres Luna — Speaker Internacional',
      metaDescription: 'Andres Luna: speaker internacional sobre liderazgo, HSE, ESG, IA Generativa, migración y crecimiento profesional para audiencias ejecutivas.',
      ogTitle: 'Charlas y Conferencias — Andres Luna',
      ogDescription: 'Speaker internacional sobre liderazgo, crecimiento profesional, innovación y transformación.',
    },
    ecosystem: {
      title: 'Ecosistema GreenIn | Innovación, Impacto y Liderazgo',
      metaDescription: 'El Ecosistema GreenIn conecta innovación, impacto social, desarrollo de coaches y liderazgo profesional a través de GreenIn Company, GreenIn Impact, GreenIn Coach y Andres Luna Coaching.',
      ogTitle: 'Ecosistema GreenIn — Andres Luna',
      ogDescription: 'Innovación, impacto y liderazgo conectados en un mismo ecosistema de crecimiento.',
    },
    blog: {
      title: 'Blog | Estrategia de Carrera y Liderazgo Profesional | Andres Luna',
      metaDescription: 'Artículos sobre estrategia de carrera, liderazgo, HSE, ESG, IA Generativa, migración profesional y posicionamiento ejecutivo por Andres Luna.',
      ogTitle: 'Blog — Andres Luna',
      ogDescription: 'Ideas y estrategias sobre crecimiento profesional, liderazgo y posicionamiento.',
    },
    books: {
      title: 'Libros y Publicaciones | Andres Luna — Liderazgo y Estrategia',
      metaDescription: 'Publicaciones y recursos sobre liderazgo, estrategia de carrera, sostenibilidad, migración e innovación por Andres Luna.',
      ogTitle: 'Libros y Publicaciones — Andres Luna',
      ogDescription: 'Recursos sobre liderazgo, carrera e innovación con impacto.',
    },
    contact: {
      title: 'Contacto | Andres Luna — Coaching Ejecutivo de Carrera',
      metaDescription: 'Conecta con Andres Luna para coaching ejecutivo, charlas, entrevistas, colaboraciones y oportunidades de crecimiento profesional.',
      ogTitle: 'Contacto — Andres Luna',
      ogDescription: 'Conecta con Andres Luna para coaching ejecutivo, charlas y colaboraciones estratégicas.',
    },
  },
  nav: {
    inicio: 'Inicio',
    coaching: 'Servicios de Coaching',
    sobre: 'Sobre Andrés',
    entrevistas: 'Entrevistas y Medios',
    charlas: 'Charlas',
    ecosistema: 'Ecosistema GreenIn',
    blog: 'Blog',
    libros: 'Recursos',
    contacto: 'Contacto',
    cta: 'Agenda tu sesión',
  },
  hero: {
    headline: 'Coaching ejecutivo con Andrés Luna: claridad, estrategia y posicionamiento para tu próximo nivel profesional.',
    subheadline: 'Coaching ejecutivo 1:1 para profesionales de las Américas que quieren crecer con dirección, visibilidad internacional y liderazgo real.',
    signature: 'Andres Luna — Executive Career Coach | HSE, ESG & Leadership Strategist | Fundador de GreenIn',
    ctaPrimary: 'Agenda tu sesión diagnóstica',
    ctaSecondary: 'Conoce los servicios',
    microcopy: 'Tu primera sesión es gratuita. Evaluamos juntos tus metas, desafíos y el mejor camino para avanzar.',
  },
  trust: {
    items: [
      '17+ años de experiencia ejecutiva internacional',
      'Fundador de GreenIn Company',
      'Speaker internacional',
      'HSE / ESG / Sustainability Executive',
      'Bilingüe: Español & English',
    ],
  },
  audience: {
    title: '¿Para quién es este coaching?',
    subtitle: 'Para profesionales de toda América Latina, Canadá, Estados Unidos y las Américas que necesitan más que experiencia: necesitan estrategia.',
    cards: [
      { title: 'Ingenieros y perfiles técnicos', description: 'Profesionales que dominan lo técnico y ahora buscan roles de liderazgo, visibilidad y posicionamiento ejecutivo.' },
      { title: 'Profesionales HSE / EHS', description: 'Especialistas en seguridad, salud y ambiente que quieren escalar hacia posiciones estratégicas e internacionales.' },
      { title: 'Líderes de Sostenibilidad y ESG', description: 'Profesionales que impulsan la transformación sostenible y necesitan posicionarse como referentes.' },
      { title: 'Project Managers y líderes de operaciones', description: 'Gestores de proyectos que buscan trascender lo operativo y crecer hacia roles ejecutivos.' },
      { title: 'Profesionales en transición', description: 'Personas que están reinventando su carrera, cambiando de industria o buscando un nuevo rumbo con propósito.' },
      { title: 'Profesionales que migran', description: 'Quienes se trasladan a otro país y necesitan una estrategia real para construir carrera, no solo conseguir empleo.' },
      { title: 'Futuros líderes', description: 'Profesionales con ambición de liderazgo que quieren prepararse con las herramientas, la claridad y la confianza necesarias.' },
    ],
  },
  why: {
    title: '¿Por qué tomar estas sesiones?',
    statements: [
      'No se trata solo de conseguir un trabajo.',
      'Se trata de construir una carrera sólida, visible y con alcance internacional.',
      'La experiencia es valiosa. Pero sin dirección, se diluye.',
      'Claridad + posicionamiento + estrategia = crecimiento real.',
    ],
  },
  outcomes: {
    title: 'Lo que trabajamos juntos',
    items: [
      'Claridad de carrera y dirección profesional',
      'Transición y reinvención profesional',
      'Liderazgo y crecimiento ejecutivo',
      'Posicionamiento y marca personal',
      'CV / Resume y perfil de LinkedIn',
      'Preparación de entrevistas y networking estratégico',
      'Internacionalización de carrera',
      'Visibilidad y autoridad profesional',
      'Propósito, impacto y siguiente nivel',
    ],
  },
  services: {
    title: 'Servicios de Coaching',
    subtitle: 'Coaching estratégico con experiencia real. No motivación genérica: un proceso claro para profesionales que buscan resultados concretos.',
  },
  ai: {
    title: 'IA Generativa, HSE, ESG y el futuro del liderazgo',
    subtitle: 'Una mirada estratégica donde convergen la inteligencia artificial, la seguridad, la sostenibilidad y el liderazgo del futuro.',
    ecosystemIntro: 'Cada paquete de coaching incluye acceso al GreenIn Coaching Ecosystem — un ecosistema premium multilingüe de coaches de IA especializados diseñados para ayudarte a crecer con claridad, credibilidad y posicionamiento estratégico.',
    ecosystemByPackage: [
      { package: 'Career Growth Session', tools: ['GreenIn Career Coach', 'GreenIn Language Mentor'] },
      { package: 'Career Acceleration Program', tools: ['GreenIn Career Coach', 'GreenIn Language Mentor', 'GreenIn Executive Positioning Coach'] },
      { package: 'Executive Career Strategy', tools: ['GreenIn Career Coach', 'GreenIn Language Mentor', 'GreenIn Executive Positioning Coach', 'GreenIn Founder & Personal Brand Coach'] },
    ],
    points: [
      'Liderar en tiempos de transformación tecnológica',
      'IA Generativa como herramienta de crecimiento profesional',
      'HSE y sostenibilidad con perspectiva de futuro',
      'Innovación aplicada con propósito y resultados',
      'Desarrollo profesional más inteligente y competitivo',
    ],
    tools: {
      title: 'GreenIn Coaching Ecosystem',
      subtitle: 'Un ecosistema premium multilingüe de coaches de IA especializados. Incluido en cada paquete — activado desde tu primera sesión.',
      items: [
        { name: 'GreenIn Career Coach', description: 'Crecimiento profesional, búsqueda de empleo y estrategia de carrera. Crece con claridad. Compite con confianza. Avanza con propósito.', href: 'https://chatgpt.com/g/g-UeaDaVjv7-greenin-career-coach', logo: 'greenin-career-coach', available: true },
        { name: 'GreenIn Language Mentor', description: 'Coach de idiomas con IA para profesionales que necesitan mejorar su comunicación en inglés o español en contextos ejecutivos.', href: '#packages', logo: 'greenin-language-mentor', available: false },
        { name: 'GreenIn Executive Positioning Coach', description: 'Marca ejecutiva, posicionamiento de liderazgo y estrategia de carrera senior. Lidera con credibilidad. Posiciónate con distinción.', href: '#packages', logo: 'greenin-executive-positioning-coach', available: false },
        { name: 'GreenIn Founder & Personal Brand Coach', description: 'Marca personal, posicionamiento de negocio y crecimiento de autoridad. Clarifica tu valor. Construye tu autoridad. Atrae las oportunidades correctas.', href: '#packages', logo: 'greenin-founder-brand-coach', available: false },
      ],
    },
  },
  ecosystem: {
    title: 'El Ecosistema GreenIn',
    subtitle: 'Innovación, impacto y liderazgo conectados en una visión integrada de crecimiento.',
    bridge: 'GreenIn construye el ecosistema. Andres Luna aporta la voz, la estrategia y la conexión humana que lo hace posible.',
    pillars: [
      { title: 'GreenIn Company', description: 'Innovación aplicada, consultoría estratégica y crecimiento seguro y sostenible para organizaciones.' },
      { title: 'GreenIn Impact', description: 'Impacto social y ambiental con visión regional, propósito y valor circular.' },
      { title: 'GreenIn Coach', description: 'La línea de negocio de GreenIn Company dedicada a apoyar, certificar y desarrollar coaches en las Américas con metodología, comunidad y visibilidad.' },
      { title: 'Andres Luna Coaching', description: 'Liderazgo, influencia y desarrollo profesional con claridad, estrategia y propósito.' },
    ],
  },
  media: {
    title: 'Entrevistas, medios y conversaciones',
    subtitle: 'Ideas y perspectivas sobre liderazgo, crecimiento profesional, migración estratégica y el futuro del trabajo.',
    items: [
      { title: 'Pilares para una Migración Exitosa', description: 'Serie de 7 episodios sobre planificación financiera, inteligencia emocional, networking y herramientas clave para migrar con estrategia y propósito.' },
      { title: 'La internacionalización de la carrera de SST', description: 'Entrevista sobre cómo proyectar tu carrera técnica a nivel internacional con visión estratégica y liderazgo multicultural.' },
    ],
  },
  blog: {
    title: 'Blog',
    subtitle: 'Estrategia, liderazgo e ideas prácticas para profesionales que quieren crecer con dirección, propósito y visibilidad.',
    comingSoon: 'Contenido estratégico en desarrollo. Mantente conectado.',
    categories: [
      'Estrategia de Carrera',
      'Liderazgo',
      'HSE / EHS',
      'ESG y Sostenibilidad',
      'IA Generativa',
      'Migración y Reinvención',
      'Marca Personal',
      'Crecimiento para Newcomers',
      'GreenIn Insights',
    ],
    featured: 'Artículo destacado',
    allArticles: 'Todos los artículos',
    readMore: 'Leer artículo',
    searchPlaceholder: 'Buscar artículos...',
    relatedArticles: 'Artículos relacionados',
    noResults: 'No se encontraron artículos.',
    allFilter: 'Todos',
    loadMore: 'Ver más artículos',
    newsletter: {
      title: '¿Quieres recibir ideas que impulsen tu carrera?',
      subtitle: 'Suscríbete para recibir contenido estratégico sobre liderazgo, posicionamiento y crecimiento profesional.',
      placeholder: 'Tu email profesional',
      cta: 'Suscribirme',
    },
    articleCta: {
      title: '¿Listo para avanzar con estrategia?',
      subtitle: 'Agenda tu sesión diagnóstica y diseñemos juntos tu próximo paso.',
    },
    posts: [
      {
        slug: 'como-internacionalizar-tu-carrera-con-estrategia',
        title: 'Cómo internacionalizar tu carrera con una estrategia realista',
        excerpt: 'Los pasos clave para proyectar tu carrera internacionalmente con visión estratégica, no solo operativa.',
        category: 'Estrategia de Carrera',
        tags: ['internacionalización', 'estrategia de carrera', 'migración', 'profesionales LATAM'],
        date: '2025-03-01',
        updatedAt: '2025-03-05',
        author: 'Andres Luna',
        readingTime: '8 min',
        pillar: 'internationalization',
        relatedSlugs: ['migrar-con-estrategia-construir-carrera', 'linkedin-estrategico-carrera-internacional'],
        seoTitle: 'Cómo internacionalizar tu carrera profesional con estrategia | Andres Luna',
        metaDescription: 'Guía estratégica para internacionalizar tu carrera profesional. Pasos clave, errores comunes y cómo posicionarte en el mercado internacional.',
        content: [
          'Internacionalizar tu carrera no es simplemente buscar empleo en otro país. Es un proceso estratégico que exige claridad sobre tu valor profesional, tu posicionamiento y tu capacidad de adaptación.',
          'Trabajando con profesionales de las Américas, he identificado patrones claros que distinguen a quienes construyen carreras internacionales sólidas de quienes simplemente "migran por un trabajo".',
          '## Los 5 pilares de la internacionalización profesional',
          '**1. Claridad de propuesta de valor.** Antes de proyectarte, necesitas articular con precisión qué problema resuelves, para quién y qué te diferencia. Esto es crítico para profesionales en HSE, ESG y sostenibilidad.',
          '**2. Posicionamiento estratégico en LinkedIn.** Tu perfil de LinkedIn no es un CV digital: es tu plataforma de autoridad profesional global.',
          '**3. Red de contactos con intención.** El networking internacional requiere estrategia. Cada conversación debe aportar valor.',
          '**4. Adaptación cultural y comunicacional.** Comprender las diferencias culturales en ambientes de trabajo internacionales es determinante.',
          '**5. Plan de acción con horizonte temporal.** Una carrera internacional se construye con pasos medibles, no con aspiraciones vagas.',
          '## Error común: confundir urgencia con estrategia',
          'Las mejores transiciones internacionales nacen de la planificación, no de la improvisación. Si estás considerando este paso, te invito a evaluar dónde estás y hacia dónde quieres ir.',
        ],
      },
      {
        slug: 'profesionales-hse-crecimiento-liderazgo',
        title: 'Qué necesitan los profesionales HSE para crecer hacia liderazgo',
        excerpt: 'El camino de especialista HSE a líder estratégico requiere más que certificaciones. Descubre qué marca la diferencia.',
        category: 'HSE / EHS',
        tags: ['HSE', 'liderazgo', 'crecimiento profesional', 'seguridad'],
        date: '2025-02-15',
        author: 'Andres Luna',
        readingTime: '7 min',
        pillar: 'hse-growth',
        relatedSlugs: ['de-especialista-tecnico-a-lider', '7-errores-crecimiento-profesional-perfiles-tecnicos'],
        seoTitle: 'Crecimiento profesional para HSE: de especialista a líder | Andres Luna',
        metaDescription: 'Qué necesitan los profesionales HSE/EHS para crecer hacia roles de liderazgo estratégico con mayor impacto organizacional.',
        content: [
          'Los profesionales de HSE son pilares de cualquier organización seria. Sin embargo, muchos permanecen en roles operativos sin acceder a posiciones de liderazgo estratégico.',
          '## El techo invisible del profesional HSE',
          'Después de años de certificaciones y gestión de riesgos, muchos sienten que han llegado a un techo. La realidad: el crecimiento hacia liderazgo requiere pasar de "ejecutor de normas" a "estratega de valor organizacional".',
          '**Lo que las organizaciones necesitan de sus líderes HSE:**',
          '- Visión estratégica que conecte seguridad con resultados de negocio',
          '- Influencia a nivel ejecutivo (C-suite)',
          '- Liderazgo de equipos multiculturales',
          '- Comprensión de ESG como marco de valor',
          '- Comunicación ejecutiva de impacto',
          '## Las 3 transiciones clave',
          '**De operativo a estratégico:** Pensar en cómo HSE genera valor competitivo, no solo compliance.',
          '**De técnico a comunicador:** Presentar datos como narrativa de impacto organizacional.',
          '**De local a global:** La experiencia internacional y la comprensión multicultural son diferenciadores decisivos.',
        ],
      },
      {
        slug: 'ia-generativa-hse-sostenibilidad-futuro',
        title: 'IA Generativa, HSE y sostenibilidad: oportunidades para el profesional del futuro',
        excerpt: 'La IA Generativa está transformando la seguridad, la sostenibilidad y el liderazgo. ¿Cómo posicionarte en esta intersección?',
        category: 'IA Generativa',
        tags: ['IA Generativa', 'HSE', 'sostenibilidad', 'futuro del trabajo', 'innovación'],
        date: '2025-02-01',
        author: 'Andres Luna',
        readingTime: '9 min',
        pillar: 'ai-future',
        relatedSlugs: ['profesionales-hse-crecimiento-liderazgo', 'esg-sostenibilidad-crecimiento-profesional'],
        seoTitle: 'IA Generativa, HSE y Sostenibilidad: oportunidades profesionales | Andres Luna',
        metaDescription: 'Cómo la IA Generativa crea nuevas oportunidades en HSE, sostenibilidad y liderazgo para el profesional del futuro.',
        content: [
          'La intersección entre IA Generativa, HSE y sostenibilidad está creando un espacio de oportunidad sin precedentes para quienes sepan posicionarse.',
          '## IA Generativa: más allá del hype',
          'No se trata de reemplazar profesionales. Se trata de amplificar capacidades, automatizar lo repetitivo y liberar espacio para el pensamiento estratégico que realmente genera valor.',
          '**Aplicaciones concretas en HSE:**',
          '- Análisis predictivo de riesgos operacionales',
          '- Generación automática de reportes de seguridad',
          '- Entrenamiento personalizado con simulaciones',
          '- Análisis de datos ambientales en tiempo real',
          '**Aplicaciones en sostenibilidad y ESG:**',
          '- Automatización de reporting ESG',
          '- Análisis de cadena de suministro sostenible',
          '- Modelado de escenarios climáticos',
          '- Comunicación de impacto basada en datos',
          '## El profesional del futuro: técnico + estratégico + digital',
          'Quienes combinen conocimiento técnico en HSE/ESG con habilidades de liderazgo y comprensión de IA tendrán una ventaja competitiva significativa.',
          'La clave no es convertirse en experto en IA, sino integrarla estratégicamente en tu práctica profesional.',
        ],
      },
      {
        slug: '7-errores-crecimiento-profesional-perfiles-tecnicos',
        title: '7 errores que frenan el crecimiento profesional de perfiles técnicos',
        excerpt: 'Los perfiles técnicos suelen cometer errores estratégicos que limitan su crecimiento. Identifícalos y supéralos.',
        category: 'Estrategia de Carrera',
        tags: ['crecimiento profesional', 'ingenieros', 'perfiles técnicos', 'errores de carrera'],
        date: '2025-01-20',
        author: 'Andres Luna',
        readingTime: '6 min',
        pillar: 'executive-coaching',
        relatedSlugs: ['de-especialista-tecnico-a-lider', 'posicionamiento-profesional-mercado-cambiante'],
        seoTitle: '7 errores que frenan tu crecimiento profesional si eres perfil técnico',
        metaDescription: 'Los 7 errores más comunes que frenan el crecimiento de ingenieros y perfiles técnicos. Supéralos con estrategia.',
        content: [
          'He trabajado con cientos de profesionales técnicos — ingenieros, especialistas HSE, project managers, líderes de sostenibilidad — y he identificado patrones que frenan su crecimiento de forma sistemática.',
          '## Error 1: Creer que más certificaciones = más crecimiento',
          'Las certificaciones son valiosas, pero no sustituyen el posicionamiento estratégico. El crecimiento real viene de combinar conocimiento técnico con visibilidad y liderazgo.',
          '## Error 2: No invertir en marca personal',
          'Tu reputación profesional se construye activamente. Si no eres visible en LinkedIn, eventos o conversaciones relevantes de tu industria, estás dejando oportunidades sobre la mesa.',
          '## Error 3: Evitar las conversaciones difíciles',
          'Negociar salario, pedir promoción, dar feedback: habilidades esenciales que los perfiles técnicos suelen postergar.',
          '## Error 4: No desarrollar comunicación ejecutiva',
          'Explicar tu impacto en lenguaje de negocio es fundamental. Los líderes no solo hacen trabajo técnico excelente: saben comunicar su valor.',
          '## Error 5: Aislarse en la especialidad',
          'Construir relaciones estratégicas fuera de tu área es clave para el crecimiento a largo plazo.',
          '## Error 6: No tener un plan de carrera a 3–5 años',
          'Sin dirección, cualquier camino parece correcto. Los profesionales que más crecen saben hacia dónde van.',
          '## Error 7: Esperar que el mérito hable por sí solo',
          'El trabajo excelente es necesario, pero no suficiente. Necesitas visibilidad, advocacy y posicionamiento.',
        ],
      },
      {
        slug: 'posicionamiento-profesional-mercado-cambiante',
        title: 'Cómo fortalecer tu posicionamiento profesional en un mercado cambiante',
        excerpt: 'En un mercado en constante evolución, tu posicionamiento es tu mayor activo. Aprende a fortalecerlo con estrategia.',
        category: 'Marca Personal',
        tags: ['posicionamiento', 'marca personal', 'mercado laboral', 'estrategia'],
        date: '2025-01-10',
        author: 'Andres Luna',
        readingTime: '7 min',
        pillar: 'executive-coaching',
        relatedSlugs: ['marca-profesional-importa-mas-de-lo-que-crees', 'linkedin-estrategico-carrera-internacional'],
        seoTitle: 'Fortalece tu posicionamiento profesional en un mercado cambiante | Andres Luna',
        metaDescription: 'Estrategias para fortalecer tu posicionamiento profesional y destacar en un mercado laboral en transformación.',
        content: [
          'El mercado laboral de hoy no premia solo la experiencia. Premia la relevancia, la visibilidad y el posicionamiento estratégico.',
          '## ¿Qué es el posicionamiento profesional?',
          'Es la percepción que el mercado tiene de ti. No es lo que haces, sino cómo el mundo te ve. Y esa percepción se puede — y se debe — construir con intención.',
          '## Los 4 pilares del posicionamiento',
          '**1. Claridad de propuesta de valor:** ¿Qué problema resuelves? ¿Para quién? ¿Qué te diferencia?',
          '**2. Visibilidad estratégica:** Estar presente donde importa: LinkedIn, eventos, publicaciones, conversaciones de industria.',
          '**3. Consistencia:** Tu mensaje, tu imagen y tu comportamiento alineados.',
          '**4. Red de valor:** Las relaciones profesionales que construyes amplifican o limitan tu alcance.',
          '## En un mercado cambiante, el posicionamiento es tu ancla',
          'Cuando las industrias se transforman y la tecnología avanza, tu posicionamiento es lo que te mantiene relevante. No esperes a que el mercado te defina.',
        ],
      },
      {
        slug: 'migrar-con-estrategia-construir-carrera',
        title: 'Migrar con estrategia: más allá del empleo, construir una carrera',
        excerpt: 'La migración profesional exitosa no se trata de conseguir empleo. Se trata de construir una carrera con visión y estrategia.',
        category: 'Migración y Reinvención',
        tags: ['migración', 'newcomers', 'Canadá', 'estrategia de carrera', 'LATAM'],
        date: '2024-12-15',
        author: 'Andres Luna',
        readingTime: '8 min',
        pillar: 'internationalization',
        relatedSlugs: ['como-internacionalizar-tu-carrera-con-estrategia', 'linkedin-estrategico-carrera-internacional'],
        seoTitle: 'Migrar con estrategia profesional: más allá del empleo | Andres Luna',
        metaDescription: 'Guía estratégica para profesionales que migran. Cómo construir una carrera internacional con propósito.',
        content: [
          'La migración profesional es una de las decisiones más transformadoras que puede tomar un profesional. Y también una de las más complejas si no se aborda con estrategia.',
          '## El error más común: buscar empleo en vez de construir carrera',
          'Muchos profesionales que migran se enfocan en conseguir empleo rápido. Es comprensible, pero limitante. La diferencia entre "encontrar trabajo" y "construir carrera" es la diferencia entre sobrevivir y prosperar.',
          '## Estrategia antes de urgencia',
          'Antes de actualizar tu CV o aplicar a cientos de posiciones, responde: ¿Cuál es tu propuesta de valor? ¿Cómo se traduce tu experiencia al nuevo mercado? ¿Qué gaps necesitas cerrar?',
          '## Los 5 pilares de la migración estratégica',
          '**1. Autoconocimiento profesional profundo** — Entiende no solo lo que sabes hacer, sino el valor que generas.',
          '**2. Investigación de mercado** — Comprende qué se demanda, cómo se contrata, qué se valora.',
          '**3. Adaptación estratégica** — Tu CV, LinkedIn y narrativa deben hablar el idioma del nuevo mercado.',
          '**4. Red de contactos intencional** — En países como Canadá, el networking no es opcional: es fundamental.',
          '**5. Mentalidad de construcción** — Piensa en 2-3 años, no en 2-3 meses.',
        ],
      },
      {
        slug: 'de-especialista-tecnico-a-lider',
        title: 'De especialista técnico a líder: el cambio que pocos preparan',
        excerpt: 'El salto de especialista a líder requiere preparación estratégica. Descubre cómo hacer la transición con éxito.',
        category: 'Liderazgo',
        tags: ['liderazgo', 'transición', 'perfiles técnicos', 'crecimiento profesional'],
        date: '2024-12-01',
        author: 'Andres Luna',
        readingTime: '7 min',
        pillar: 'executive-coaching',
        relatedSlugs: ['7-errores-crecimiento-profesional-perfiles-tecnicos', 'profesionales-hse-crecimiento-liderazgo'],
        seoTitle: 'De especialista técnico a líder: prepara tu transición | Andres Luna',
        metaDescription: 'Cómo preparar la transición de especialista técnico a líder. Estrategias, habilidades y mentalidad para el siguiente nivel.',
        content: [
          'El camino de especialista técnico a líder es uno de los más gratificantes — y uno de los más subestimados en su complejidad.',
          '## ¿Por qué tantos profesionales técnicos fracasan como líderes?',
          'Porque asumen que las habilidades que los hicieron excelentes especialistas son las mismas que los harán buenos líderes. No lo son.',
          '## Las 3 grandes transformaciones',
          '**De hacer a habilitar:** Como especialista, tu valor estaba en hacer. Como líder, tu valor está en habilitar a otros.',
          '**De conocimiento técnico a inteligencia emocional:** Entender personas, motivaciones, conflictos y dinámicas de equipo.',
          '**De individual a sistémico:** Pensar en cómo funciona todo el sistema organizacional, no solo tu trabajo.',
          '## Cómo preparar la transición',
          '- Busca mentores que ya hayan hecho la transición',
          '- Desarrolla comunicación ejecutiva',
          '- Practica la delegación activamente',
          '- Construye tu marca de liderazgo antes de necesitarla',
          '- Invierte en coaching ejecutivo como acelerador',
          'La transición de especialista a líder no sucede por accidente. Se diseña, se prepara y se ejecuta con intención.',
        ],
      },
      {
        slug: 'marca-profesional-importa-mas-de-lo-que-crees',
        title: 'Por qué la marca profesional importa más de lo que crees',
        excerpt: 'Tu marca profesional es tu reputación estratégica. Es clave para tu crecimiento y se construye con intención.',
        category: 'Marca Personal',
        tags: ['marca personal', 'LinkedIn', 'posicionamiento', 'visibilidad profesional'],
        date: '2024-11-15',
        author: 'Andres Luna',
        readingTime: '6 min',
        pillar: 'executive-coaching',
        relatedSlugs: ['posicionamiento-profesional-mercado-cambiante', 'linkedin-estrategico-carrera-internacional'],
        seoTitle: 'La marca profesional importa más de lo que crees | Andres Luna',
        metaDescription: 'Tu marca profesional es clave para tu crecimiento. Aprende a construirla con estrategia e intención.',
        content: [
          'Tu marca profesional no es tu logo ni tu foto de LinkedIn. Es la percepción que el mundo tiene de ti como profesional. Y esa percepción impacta directamente las oportunidades que llegan a tu vida.',
          '## Marca profesional = reputación estratégica',
          'Cada interacción, publicación, presentación y conversación contribuye. La pregunta es: ¿la estás construyendo con intención o dejando que se forme por accidente?',
          '## Los 5 elementos de una marca profesional sólida',
          '**1. Narrativa clara:** ¿Cuál es tu historia profesional? ¿Qué problema resuelves? ¿Hacia dónde vas?',
          '**2. Presencia digital:** LinkedIn es tu plataforma principal. ¿Está optimizado para mostrar tu valor?',
          '**3. Contenido de valor:** Compartir conocimiento te posiciona como referente.',
          '**4. Red estratégica:** Las personas con las que te asocias dicen mucho sobre ti.',
          '**5. Consistencia:** Coherencia entre lo que dices, lo que haces y cómo te presentas.',
          '## El retorno de la marca profesional',
          'Los profesionales con marcas fuertes reciben más ofertas, son invitados a más eventos y tienen mayor capacidad de negociación. No es vanidad: es estrategia.',
        ],
      },
      {
        slug: 'esg-sostenibilidad-crecimiento-profesional',
        title: 'ESG y sostenibilidad como camino de crecimiento profesional',
        excerpt: 'El mundo ESG ofrece oportunidades únicas de crecimiento. Aprende a posicionarte en este campo estratégico.',
        category: 'ESG y Sostenibilidad',
        tags: ['ESG', 'sostenibilidad', 'crecimiento profesional', 'liderazgo'],
        date: '2024-11-01',
        author: 'Andres Luna',
        readingTime: '8 min',
        pillar: 'esg-sustainability',
        relatedSlugs: ['ia-generativa-hse-sostenibilidad-futuro', 'profesionales-hse-crecimiento-liderazgo'],
        seoTitle: 'ESG y sostenibilidad: oportunidades de crecimiento profesional | Andres Luna',
        metaDescription: 'Cómo aprovechar el crecimiento del campo ESG y sostenibilidad para impulsar tu carrera con estrategia.',
        content: [
          'El campo de ESG y sostenibilidad está en pleno crecimiento. Y con ese crecimiento llegan oportunidades extraordinarias para quienes sepan posicionarse.',
          '## El contexto: ESG como imperativo estratégico',
          'Ya no es tendencia. Es requisito regulatorio, diferenciador competitivo y expectativa de stakeholders. Las organizaciones necesitan profesionales que entiendan ESG como estrategia de valor, no solo compliance.',
          '## Oportunidades profesionales en ESG',
          '- Liderazgo en sostenibilidad corporativa',
          '- Consultoría ESG para empresas en transición',
          '- Gestión de reportes y métricas ESG',
          '- Integración de sostenibilidad en cadenas de valor',
          '- Innovación sostenible y economía circular',
          '## Cómo posicionarte',
          '**1. Conecta tu experiencia con ESG:** Si vienes de HSE, gestión de riesgos o ingeniería, ya tienes bases sólidas.',
          '**2. Desarrolla conocimiento específico:** Certificaciones en GRI, SASB, TCFD complementan tu perfil.',
          '**3. Construye narrativa de sostenibilidad:** Posiciona tu experiencia en el contexto de impacto y valor.',
          '**4. Conecta con el ecosistema:** Participa en eventos, comunidades y conversaciones de ESG.',
          'El futuro de muchas industrias pasa por la sostenibilidad. Posicionarte hoy es invertir en tu ventaja de mañana.',
        ],
      },
      {
        slug: 'linkedin-estrategico-carrera-internacional',
        title: 'Cómo usar LinkedIn estratégicamente para proyectar tu carrera internacional',
        excerpt: 'LinkedIn es mucho más que un CV online. Aprende a usarlo como herramienta estratégica de proyección internacional.',
        category: 'Estrategia de Carrera',
        tags: ['LinkedIn', 'internacionalización', 'marca personal', 'networking'],
        date: '2024-10-15',
        author: 'Andres Luna',
        readingTime: '7 min',
        pillar: 'executive-coaching',
        relatedSlugs: ['marca-profesional-importa-mas-de-lo-que-crees', 'como-internacionalizar-tu-carrera-con-estrategia'],
        seoTitle: 'LinkedIn estratégico para carrera internacional | Andres Luna',
        metaDescription: 'Guía para usar LinkedIn estratégicamente y proyectar tu carrera profesional internacional con visibilidad y propósito.',
        content: [
          'LinkedIn es la plataforma profesional más poderosa del mundo. Pero la mayoría la usa como un CV estático, desperdiciando su verdadero potencial.',
          '## LinkedIn no es un CV. Es una plataforma de autoridad.',
          'La diferencia entre un perfil mediocre y uno estratégico es la misma diferencia entre ser invisible y ser referente en tu campo.',
          '## Las 7 claves del LinkedIn estratégico',
          '**1. Headline que vende tu valor, no tu cargo.**',
          '**2. About section como narrativa de impacto.**',
          '**3. Experiencia orientada a resultados.**',
          '**4. Contenido regular y relevante.**',
          '**5. Networking intencional.**',
          '**6. Recomendaciones estratégicas.**',
          '**7. Perfil bilingüe si buscas mercado internacional.**',
          'Tu perfil de LinkedIn trabaja para ti 24/7. Asegúrate de que cuente la historia correcta.',
        ],
      },
    ],
  },
  books: {
    title: 'Recursos Recomendados',
    subtitle: 'Libros, cursos, herramientas y recursos seleccionados para acelerar tu crecimiento profesional.',
    comingSoon: 'Recursos en desarrollo. Mantente conectado para las novedades.',
    contentTypes: ['Libro', 'Publicación', 'Guía', 'Entrevista', 'Podcast', 'Recurso'],
    categories: {
      'HSE': 'HSE',
      'ESG': 'ESG',
      'Leadership': 'Liderazgo',
      'Organizational Development': 'Desarrollo Organizacional',
      'Applied AI': 'IA Aplicada',
      'Coaching': 'Coaching',
      'Sustainability': 'Sostenibilidad',
      'Career Strategy': 'Estrategia de Carrera',
      'Migration': 'Migración',
    },
    allFilter: 'Todos',
    featuredSection: 'Lecturas Destacadas',
    buyNow: 'Obtener libro',
    noBooks: 'Libros próximamente. Mantente conectado.',
    noBooksInCategory: 'Aún no hay libros en esta categoría.',
  },
  resources: {
    hubTitle: 'Resource Hub',
    hubSubtitle: 'Todo lo que necesitas para crecer: libros, cursos, templates y herramientas — curados para profesionales ambiciosos.',
    tabs: {
      books: 'Libros',
      courses: 'Cursos',
      library: 'Biblioteca',
      training: 'Entrenamiento',
    },
    searchPlaceholder: 'Buscar recursos...',
    viewCourse: 'Ver curso',
    downloadResource: 'Descargar',
    noResources: 'Recursos próximamente. Mantente conectado.',
    shopTitle: 'GreenIn Shop',
    shopDescription: 'Execution & Circular Impact — Marketplace de herramientas de ejecución HSE & ESG con impacto circular.',
    shopCta: 'Explorar GreenIn Shop',
    professionFilter: 'Profesión',
    allProfessions: 'Todas las profesiones',
  },
  contact: {
    title: 'Conversemos',
    subtitle: 'Estoy disponible para coaching ejecutivo, charlas, entrevistas, colaboraciones y oportunidades de crecimiento con impacto real.',
    directContact: 'Contacto directo',
    form: {
      name: 'Nombre completo',
      email: 'Email profesional',
      country: 'País',
      linkedin: 'LinkedIn (opcional)',
      message: '¿En qué puedo ayudarte?',
      interest: 'Tipo de consulta',
      interests: ['Coaching', 'Paquete Personalizado', 'Charlas / Conferencias', 'Medios / Entrevistas', 'Colaboración', 'Otro'],
      submit: 'Enviar mensaje',
      success: 'Gracias por tu mensaje. Lo he recibido correctamente y te responderé lo antes posible.',
      successSubtext: 'Si prefieres, también puedes agendar directamente una sesión diagnóstica gratuita.',
      successBookingCta: 'Agendar sesión',
      helperText: 'Tus datos serán usados únicamente para orientarte mejor y responder a tu solicitud.',
      privacy: 'Tu información es confidencial. No compartimos tus datos con terceros.',
      errors: {
        nameRequired: 'Por favor ingresa tu nombre.',
        emailRequired: 'Ingresa un correo electrónico.',
        emailInvalid: 'Ingresa un correo electrónico válido.',
        countryRequired: 'Selecciona tu país.',
        interestRequired: 'Selecciona un tipo de consulta.',
        messageRequired: 'Escribe tu mensaje.',
        fieldRequired: 'Este campo es obligatorio.',
      },
    },
  },
  bookingFunnel: {
    title: 'Agenda tu sesión diagnóstica',
    subtitle: 'Completa estos datos para orientarte mejor antes de tu sesión.',
    helperText: 'Esta información me ayudará a entender mejor tu perfil y objetivos.',
    fields: {
      name: 'Nombre completo',
      email: 'Email profesional',
      country: 'País',
      profession: 'Área profesional',
      professionOptions: [
        'Ingeniería',
        'HSE / EHS',
        'ESG / Sostenibilidad',
        'Project Management',
        'Liderazgo / Management',
        'Otra',
      ],
      careerMoment: 'Momento actual de carrera',
      careerMomentOptions: [
        'Buscando claridad profesional',
        'En transición laboral',
        'Quiero crecer hacia liderazgo',
        'Quiero internacionalizar mi carrera',
        'Quiero fortalecer mi posicionamiento',
        'Otro',
      ],
      mainGoal: 'Principal objetivo',
      mainGoalOptions: [
        'Definir mi siguiente paso',
        'Mejorar mi perfil profesional',
        'Prepararme para liderazgo',
        'Internacionalizar mi carrera',
        'Mejorar entrevistas / networking',
        'Otro',
      ],
      referral: '¿Cómo conociste este sitio? (opcional)',
      referralPlaceholder: 'LinkedIn, Google, referido...',
    },
    submit: 'Continuar',
    submitting: 'Enviando...',
    thankYou: {
      title: 'Gracias. Tu información fue recibida.',
      subtitle: 'El siguiente paso es reservar tu sesión diagnóstica gratuita en el calendario.',
      calendarCta: 'Ir al calendario',
      whatsappCta: 'Escribirme por WhatsApp',
      backCta: 'Volver al sitio',
      closingLine: 'Estás más cerca de construir una carrera con mayor claridad, estrategia y propósito.',
    },
    errors: {
      nameRequired: 'Por favor ingresa tu nombre.',
      emailRequired: 'Ingresa un correo electrónico.',
      emailInvalid: 'Ingresa un correo electrónico válido.',
      countryRequired: 'Selecciona tu país.',
      professionRequired: 'Selecciona tu área profesional.',
      careerMomentRequired: 'Selecciona tu momento actual.',
      mainGoalRequired: 'Selecciona tu principal objetivo.',
    },
  },
  speakingInquiry: {
    title: 'Solicitud para charla o conferencia',
    subtitle: 'Cuéntame sobre tu evento y exploremos cómo colaborar.',
    helperText: 'Completa los datos básicos para evaluar la mejor opción para tu evento.',
    fields: {
      name: 'Nombre',
      organization: 'Organización',
      email: 'Email',
      country: 'País',
      eventType: 'Tipo de evento',
      eventTypeOptions: ['Conferencia', 'Panel', 'Taller', 'Podcast / Entrevista', 'Webinar', 'Sesión ejecutiva', 'Otro'],
      estimatedDate: 'Fecha estimada',
      topic: 'Tema de interés',
      topicOptions: [
        'Liderazgo con propósito',
        'HSE / ESG como valor estratégico',
        'IA Generativa y futuro del trabajo',
        'Migración profesional',
        'Marca profesional y liderazgo',
        'Otro',
      ],
      message: 'Mensaje adicional',
    },
    submit: 'Enviar solicitud',
    success: 'Gracias por tu interés. He recibido tu solicitud correctamente.',
    successSubtext: 'Te responderé lo antes posible. También puedes escribirme directamente:',
  },
  whatsapp: {
    tooltip: '¿Tienes una pregunta rápida?',
    prefilled: 'Hola Andrés, estoy interesado(a) en tus sesiones de Executive Career Coaching y me gustaría recibir más información.',
  },
  coaching: {
    heroTitle: 'Coaching Ejecutivo 1:1',
    heroSubtitle: 'Un proceso estratégico, humano y práctico para avanzar con claridad, mejor posicionamiento y un plan de acción real.',
    differenceTitle: '¿Qué hace diferente este coaching?',
    differenceText: 'Se basa en experiencia ejecutiva real, liderazgo multicultural, comprensión profunda del mercado de las Américas, y una visión que integra IA, sostenibilidad y el futuro del trabajo. Las sesiones están diseñadas para integrar herramientas de Inteligencia Artificial y Agentes IA que optimizan tareas clave: revisión de Resume, Cover Letter, coaching de idiomas y gestión de procesos de carrera. No es motivación genérica. Es estrategia aplicada con innovación real.',
    audienceTitle: '¿Para quién es?',
    whyTitle: '¿Por qué tomarlo?',
    whyText: 'Porque el crecimiento profesional hoy exige más que experiencia: exige claridad de dirección, posicionamiento estratégico, decisiones inteligentes y visibilidad con propósito.',
    packagesTitle: 'Paquetes y servicios',
    packages: [
      {
        name: 'Sesión Diagnóstica Gratuita',
        price: 'Gratis',
        duration: '30 a 45 minutos',
        description: 'Evaluamos tu situación actual, tus metas y definimos juntos el mejor camino para avanzar.',
        features: ['Diagnóstico de situación actual', 'Identificación de metas y bloqueos', 'Definición de próximos pasos'],
        cta: 'Agenda tu sesión',
        badge: 'Comienza aquí',
        idealFor: 'Para profesionales que quieren explorar el coaching antes de comprometerse.',
      },
      {
        name: 'Career Growth Session',
        price: 'Desde USD $70',
        duration: '45 a 60 minutos',
        description: 'Sesión individual enfocada en un desafío específico: claridad, perfil, entrevistas o visibilidad. Incluye acceso a herramientas de IA para optimización de carrera.',
        features: ['Claridad profesional', 'Revisión de perfil con IA', 'Entrevistas y networking', 'Liderazgo y visibilidad', 'Acceso a GreenIn Career Coach (IA)'],
        cta: 'Reservar sesión',
        idealFor: 'Para resolver un desafío puntual con enfoque estratégico e IA aplicada.',
      },
      {
        name: 'Career Acceleration Program',
        price: 'Desde USD $195',
        duration: '3 sesiones',
        description: 'Estrategia integral: revisión de CV/Resume con IA, optimización de LinkedIn, preparación de entrevistas y plan de acción personalizado con agentes de IA.',
        features: ['Estrategia de carrera con IA', 'CV y LinkedIn optimizados con agentes', 'Preparación de entrevistas', 'Coach de idiomas con IA', 'Plan de acción claro'],
        cta: 'Comenzar programa',
        idealFor: 'Para profesionales en transición que necesitan estructura y tecnología.',
      },
      {
        name: 'Executive Career Strategy',
        price: 'Desde USD $295',
        duration: '5 sesiones',
        description: 'Posicionamiento ejecutivo integral: estrategia de liderazgo, marca personal, planificación de transición, networking y accountability — todo potenciado con herramientas de IA y agentes especializados.',
        features: ['Posicionamiento ejecutivo', 'Estrategia de liderazgo con IA', 'Marca personal', 'Networking estratégico', 'Coach de idiomas con IA', 'Accountability con agentes'],
        cta: 'Iniciar estrategia',
        badge: 'Más solicitado',
        idealFor: 'Para profesionales que buscan un crecimiento integral, innovador y de largo plazo.',
      },
      {
        name: 'Paquetes Personalizados',
        price: 'A medida',
        duration: 'Programa personalizado',
        description: 'Para newcomers, profesionales migrantes, equipos pequeños, mentoría especializada y apoyo a la internacionalización.',
        features: ['Programa a medida', 'Newcomers y migrantes', 'Equipos y mentoría', 'Internacionalización'],
        cta: 'Consultar disponibilidad',
        idealFor: 'Para necesidades específicas, equipos o situaciones que requieren un enfoque particular.',
      },
    ],
    howTitle: 'Cómo funciona',
    steps: [
      { title: 'Agenda tu sesión', description: 'Reserva un espacio para tu sesión diagnóstica sin costo.' },
      { title: 'Evaluamos metas y oportunidades', description: 'Analizamos tu situación, fortalezas y áreas de crecimiento con claridad.' },
      { title: 'Definimos la mejor ruta', description: 'Diseñamos un plan estratégico personalizado para tu carrera.' },
      { title: 'Comenzamos a trabajar', description: 'Avanzamos juntos hacia tus objetivos con estructura y accountability.' },
    ],
    testimonialsTitle: 'Lo que dicen los clientes',
    testimonials: [
      { quote: 'Trabajar con Andrés me dio la claridad y la confianza que necesitaba para conseguir mi siguiente rol ejecutivo en un nuevo país. Su enfoque estratégico es inigualable.', name: 'Carolina M.', role: 'Directora HSE', country: 'Colombia → Canadá' },
      { quote: 'Las sesiones de coaching me ayudaron a redefinir mi narrativa profesional y posicionarme como líder, no solo como experto técnico. Un antes y un después.', name: 'Ricardo T.', role: 'Gerente ESG', country: 'Brasil → EE.UU.' },
      { quote: 'Andrés combina experiencia ejecutiva real con empatía genuina. No solo hace coaching — mentoriza con propósito y precisión.', name: 'María Elena S.', role: 'VP de Operaciones', country: 'México' },
      { quote: 'Después de años sintiéndome estancado, tres sesiones fueron suficientes para construir una hoja de ruta clara. Me promovieron en cuatro meses.', name: 'Daniel F.', role: 'Líder de Proyecto', country: 'Chile → Australia' },
    ],
  },
  about: {
    heroTitle: 'Sobre Andrés Luna',
    heroSubtitle: 'Executive Career Coach, líder en HSE / ESG, emprendedor, speaker y conector de personas, ideas y oportunidades.',
    storyTitle: 'Mi historia',
    storyText: [
      'Con más de 17 años de experiencia ejecutiva internacional en HSE, ESG, sostenibilidad, gestión de riesgos, liderazgo y gestión de proyectos, he trabajado en industrias como energía, construcción, FMCG y entornos multiculturales en más de 6 países.',
      'He liderado equipos, gestionado operaciones complejas y construido estrategias en contextos exigentes. Esa trayectoria me dio una convicción: el crecimiento profesional no es lineal, no es solo técnico y requiere una visión estratégica que integre liderazgo, posicionamiento, innovación y propósito.',
      'Hoy, como fundador de GreenIn Company y Executive Career Coach, ayudo a profesionales de las Américas a crecer, reinventarse e internacionalizar su carrera. Con estrategia, con claridad y con la confianza que da la experiencia real.',
    ],
    mission: 'Ayudar a profesionales a crecer, reinventarse e internacionalizar su carrera con estrategia, claridad y propósito.',
    vision: 'Un desarrollo profesional más humano, más estratégico y más conectado con el futuro del trabajo, el liderazgo y la innovación con impacto.',
    valuesTitle: 'Lo que aporto',
    values: [
      'Experiencia ejecutiva real en múltiples industrias y países',
      'Visión regional e internacional del mercado profesional',
      'Liderazgo multicultural y comprensión intercultural profunda',
      'Conocimiento técnico y estratégico de HSE, ESG e industrias clave',
      'Coaching con profundidad humana y enfoque práctico',
      'Integración entre carrera, liderazgo, IA y sostenibilidad',
    ],
    metrics: [
      { value: '17+', label: 'Años de experiencia' },
      { value: '6+', label: 'Países' },
      { value: '2', label: 'Empresas fundadas' },
      { value: '100+', label: 'Profesionales impactados' },
    ],
    credentialsTitle: 'Trayectoria y credenciales',
    credentials: [
      'Executive Career Coach certificado',
      'Fundador de GreenIn Company',
      'Fundador de GreenIn Impact',
      'Speaker internacional',
      'Líder ejecutivo en HSE, ESG y sostenibilidad',
      'Experiencia en energía, construcción y FMCG',
      'Bilingüe: Español e Inglés',
      'Trayectoria en Canadá, Latinoamérica y las Américas',
    ],
    speakingTitle: 'Charlas y Conferencias',
    speakingSubtitle: 'Keynotes y talleres sobre liderazgo, sostenibilidad, crecimiento profesional y el futuro del trabajo.',
    speakingCta: '¿Te gustaría invitarme a tu evento?',
  },
  interviews: {
    heroTitle: 'Entrevistas, medios y conversaciones',
    heroSubtitle: 'Ideas y perspectivas sobre liderazgo, crecimiento profesional, migración estratégica y el futuro del trabajo.',
    introText: 'Comunicar también es liderar. Cada conversación es una oportunidad de inspirar, educar y conectar con profesionales que buscan crecer con propósito.',
    whyTitle: '¿Por qué importan estas conversaciones?',
    whyText: 'Porque las ideas que compartimos moldean las decisiones que tomamos. Cada entrevista, podcast o artículo es una invitación a pensar diferente sobre tu carrera, tu liderazgo y tu impacto.',
  },
  talks: {
    heroTitle: 'Charlas, conferencias y colaboraciones',
    heroSubtitle: 'Disponible para conferencias, paneles, talleres, podcasts y espacios de conversación estratégica sobre liderazgo, innovación y crecimiento profesional.',
    introText: 'Mi enfoque como speaker combina experiencia ejecutiva real con una visión estratégica del liderazgo, la sostenibilidad y el futuro del trabajo. Cada presentación busca dejar ideas claras, aplicables y que generen reflexión.',
    topicsTitle: 'Temas disponibles',
    topics: [
      { title: 'Liderazgo con propósito', description: 'Cómo liderar con visión, impacto y autenticidad en un mundo que cambia rápido.' },
      { title: 'Crecimiento profesional e internacionalización', description: 'Estrategias para construir carreras internacionales con claridad, posicionamiento y propósito.' },
      { title: 'HSE / ESG como valor estratégico', description: 'Cómo posicionar seguridad y sostenibilidad como ventaja competitiva real.' },
      { title: 'IA Generativa y el futuro de HSE y sostenibilidad', description: 'Oportunidades concretas de IA aplicada en seguridad, sostenibilidad y liderazgo.' },
      { title: 'Innovación con impacto', description: 'Cómo generar innovación que combine propósito, tecnología y resultados medibles.' },
      { title: 'Liderazgo multicultural', description: 'Liderar equipos diversos en entornos internacionales con inteligencia cultural y empatía estratégica.' },
      { title: 'Migración profesional y reinvención', description: 'El camino estratégico de la migración: construir carrera, no solo buscar empleo.' },
      { title: 'Marca profesional y posicionamiento ejecutivo', description: 'Construir una marca profesional que atraiga oportunidades, no que las persiga.' },
    ],
    ctaTitle: '¿Te gustaría invitarme a tu evento?',
    ctaSubtitle: 'Disponible para conferencias, paneles, talleres, podcasts y sesiones estratégicas con audiencias ejecutivas.',
    formatsTitle: 'Formatos disponibles',
    formats: ['Conferencia magistral', 'Panel de expertos', 'Taller interactivo', 'Podcast / Entrevista', 'Webinar', 'Sesión ejecutiva privada'],
  },
  footer: {
    tagline: 'Executive Career Coach | HSE, ESG & Leadership Strategist',
    rights: 'Todos los derechos reservados.',
    privacy: 'Política de Privacidad',
    terms: 'Términos y Condiciones',
    navigation: 'Navegación',
    more: 'Más',
    contact: 'Contacto',
    legal: 'Legal',
    adminAccess: 'Panel Admin',
  },
  common: {
    bookSession: 'Agenda tu sesión',
    exploreServices: 'Conoce los servicios',
    viewPackages: 'Ver paquetes',
    viewInterviews: 'Ver entrevistas',
    inviteToTalk: 'Invítame a una charla',
    knowGreenin: 'Conoce GreenIn',
    goToBlog: 'Ir al Blog',
    viewPublications: 'Ver publicaciones',
    contactMe: 'Contáctame',
    learnMore: 'Saber más',
    visit: 'Visitar',
    backToHome: 'Volver al inicio',
    pageNotFound: 'Página no encontrada',
    pageNotFoundText: 'Lo sentimos, la página que buscas no existe.',
    breadcrumbHome: 'Inicio',
    readAlso: 'Lee también',
    shareArticle: 'Compartir artículo',
  },
};
